import script from "./AdminFlows.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFlows.vue?vue&type=script&setup=true&lang=js"

import "./AdminFlows.vue?vue&type=style&index=0&id=5b9babf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9babf6"]])

export default __exports__